import Vue from 'vue'
import App from './App.vue'
import router from './router'

import 'element-ui/packages/theme-chalk/lib/index.css'

import Element from 'element-ui'
import GlpUI from '@@/index'
import '@@/styles/index.scss'
import '@@/styles/icons/iconfont.css'
Vue.config.productionTip = false

Vue.use(Element)
Vue.use(GlpUI)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
